import React from 'react';
import PropTypes from 'prop-types';
import { Text, Box } from '@nerdwallet/currency';

import classNames from 'classnames';
import {
  boolCheckboxSpec,
  repeatable,
  stringInputSpec,
  textColorPicker,
} from '../../lib/editing-configs';
import getTextColor from '~/client/lib/text-color-config';

import Row from '../row/row';
import Tile from './tile';

import './category-tiles.less';

const CategoryTiles = ({ columns, headerText, overlap, textColor, tiles }) => {
  // generate tiles
  const tileSections = tiles.map((tile) => <Tile {...tile} key={tile.title} />);
  const { textColor: textColorOption } = getTextColor({ textColor });
  const colorStyle = { color: textColorOption };
  return (
    <div
      className={classNames(
        { 'top-overlap': overlap },
        'category-tiles__wrapper'
      )}
    >
      <div className="category-tiles landing-page-narrow__max-widths">
        {headerText && (
          <Box
            className={classNames([
              'category-tiles__title',
              'centered-in-parent',
            ])}
            style={colorStyle}
          >
            <Text bold>{headerText}</Text>
          </Box>
        )}
        <Row centeredInParent className="category-list" columns={columns}>
          {tileSections}
        </Row>
      </div>
    </div>
  );
};

CategoryTiles.displayName = 'CategoryTiles';

CategoryTiles.propTypes = {
  columns: PropTypes.string,
  headerText: PropTypes.string,
  textColor: PropTypes.string,
  overlap: PropTypes.bool,
  tiles: PropTypes.arrayOf(
    PropTypes.shape({
      iconUrl: PropTypes.string,
      highlightIconUrl: PropTypes.string,
      linkUrl: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.oneOf(['active', 'inactive']),
    })
  ),
};

CategoryTiles.defaultProps = {
  columns: '1',
  overlap: false,
  headerText: 'Enter header text here.',
  headerTextColor: 'neutral-darkest',
  tiles: [],
};

CategoryTiles.getEditingConfig = () => [
  ...Row.getEditingConfig(),
  textColorPicker,
  stringInputSpec('headerText', 'Header text'),
  boolCheckboxSpec('overlap', 'Top overlap', {
    help: 'The top of tiles overlap with previous builder element.',
  }),
  repeatable('tiles', 'Tiles', 'Tile', () => Tile.getEditingConfig()),
];

export default CategoryTiles;
